/**
 * Admin permission catalog (mirror of backend `constants/permissions.ts`).
 *
 * Permissions only matter for SUPPORT_ADMIN. SUPER_ADMIN implicitly has every
 * permission — `hasPermission` always returns true for them.
 *
 * Keep in sync with `backend/src/constants/permissions.ts`.
 */
export interface AdminPermissionDef {
  key: string
  label: string
  group: string
}

export const ADMIN_PERMISSIONS: AdminPermissionDef[] = [
  { key: 'schools.view', label: 'View yoga schools', group: 'Yoga Schools' },
  { key: 'schools.manage', label: 'Edit / approve / reject schools', group: 'Yoga Schools' },
  { key: 'schools.onboard', label: 'Onboard new schools', group: 'Yoga Schools' },
  { key: 'registrations.view', label: 'View new school registrations', group: 'Yoga Schools' },

  { key: 'courses.view', label: 'View courses', group: 'Courses' },
  { key: 'courses.manage', label: 'Create / edit / delete courses', group: 'Courses' },

  { key: 'users.view', label: 'View users', group: 'Users' },
  { key: 'users.manage', label: 'Edit / activate / delete users', group: 'Users' },

  { key: 'bookings.view', label: 'View bookings', group: 'Bookings' },

  { key: 'testimonials.manage', label: 'Manage testimonials', group: 'Content' },
  { key: 'faqs.manage', label: 'Manage FAQs', group: 'Content' },
  { key: 'blog.manage', label: 'Manage blog', group: 'Content' },

  { key: 'consultations.manage', label: 'Manage consultations', group: 'Consultations' },

  { key: 'analytics.view', label: 'View analytics', group: 'Analytics' },
]

export const ALL_ADMIN_PERMISSION_KEYS: string[] = ADMIN_PERMISSIONS.map((p) => p.key)

export const DEFAULT_SUPPORT_ADMIN_PERMISSIONS: string[] = [
  'schools.view',
  'schools.onboard',
  'registrations.view',
]

export const PERMISSION_GROUPS: string[] = Array.from(
  new Set(ADMIN_PERMISSIONS.map((p) => p.group)),
)

export const groupedPermissions = (): Record<string, AdminPermissionDef[]> => {
  return ADMIN_PERMISSIONS.reduce<Record<string, AdminPermissionDef[]>>((acc, perm) => {
    if (!acc[perm.group]) acc[perm.group] = []
    acc[perm.group].push(perm)
    return acc
  }, {})
}
